import { createAppRootRoute } from '@core/utils/router/create-app-root-route'
import { ROUTES } from '@platform/router/paths'

export const Route = createAppRootRoute(ROUTES.root)
